<template>
  <div class="conponentTable">
    <div class="title flex-xc-yc" v-if="config.title">
      <span v-html="config.title"></span>
    </div>

    <table border="1">
      <thead>
        <tr v-for="i in level" :key="i">
          <template v-for="(item, j) in columns">
            <td
              v-if="item.level == i"
              :key="i + ' ' + j"
              :rowspan="item.rowSpan"
              :colspan="item.colSpan"
            >
              <span v-html="item.text"></span>
            </td>
          </template>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, i) in tableData" :key="i">
          <td v-for="(thItem, j) in columns.filter(x => x.key)" :key="j">
            <span>{{ item[thItem.key] }}</span>
          </td>
        </tr>
        <tr v-if="config.remarks">
          <td :colspan="columns.length">
            <span>{{ config.remarks }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { deepClone } from '../../utils/deepClone'
export default {
  name: 'Table', //表格
  props: {
    tableConfig: Object,
    tableData: Array
  },
  data() {
    return {
      config: {},
      columns: [],
      level: 1
    }
  },
  created() {
    this.config = deepClone(this.tableConfig)
    this.getColumnConfig(this.config.columns, 1)
    this.setRowSpan(this.config.columns, this.level)
  },
  methods: {
    getColumnConfig(columns, level) {
      if (level > this.level) {
        this.level = level
      }
      columns.forEach(item => {
        // 合并行属性
        item.rowSpan = 1
        // 合并列属性
        item.colSpan = 1
        if (item.sub) {
          // 使用递归 遍历深层数据
          this.getColumnConfig(item.sub, level + 1)
          item.colSpan += item.sub.length - 1
          item.sub.forEach(subItem => {
            item.rowSpan += subItem.rowSpan - 1
            item.colSpan += subItem.colSpan - 1
          })
        }
      })
    },
    setRowSpan(columns, level) {
      columns.forEach(item => {
        if (item.key !== 'ratio' && item.key !== 'unit') {
          const nItem = { ...item }
          nItem.level = this.level - level + 1
          this.columns.push(nItem)
          if (item.key) {
            nItem.rowSpan = level
          } else if (item.sub) {
            this.setRowSpan(item.sub, level - 1)
          }
        } else {
          return
        }
      })
    }
  }
}
</script>

<style>
.conponentTable {
  width: 100%;
  font-size: 14px;
  color: #5f5f5f;
  overflow: auto;
  padding-bottom: 10px;
}
.conponentTable table {
  min-width: 100%;
  color: #5f5f5f;
  border-spacing: 0;
  border-color: #fff;
  border-collapse: separate;
  font-size: 14px;
  text-align: center;
  /* white-space: nowrap; */
}
.conponentTable::-webkit-scrollbar {
  display: none;
}
.van-dialog *::-webkit-scrollbar {
  display: none;
}
.conponentTable tr {
  padding: 0;
  margin: 0;
}
.conponentTable td {
  min-width: 40px;
  padding: 5px;
  margin: 0;
  box-sizing: border-box;
  /* max-width: 20%; */
}
.conponentTable .title {
  padding: 40px;
  font-size: 16px;
  color: #111;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/Table.vue